export default {
  mitigationHabitats: [],
  loading: false
}
